import { ApplicationForm } from './ApplicationForm'
import { Box } from '@mui/material'
import { Navbar } from '../../components/Navbar'
import { Footer } from '../../components/Footer'
import { PageContainer } from '../../components/styled/PageContainer'

export const NexenExchangeForm = () => {
  return (
    <Box>
      <Navbar />
      <PageContainer>
        <ApplicationForm />

        {/* <TitleContainer text={"Form"} bgcolor="#dcdcdc" /> */}
        {/* <Box
          backgroundColor='#001450'
          color='#fff'
          minHeight={100}
          display='flex'
          justifyContent='center'
          alignItems='center'
          position='relative'
          zIndex={200}
        >
          <Typography variant='h1' sx={{ fontSize: { xs: '24px', sm: '28px' } }}>
            Form
          </Typography>
        </Box> */}
      </PageContainer>
      <Footer />
    </Box>
  )
}
